module.exports = __webpack_public_path__ + "static/media/customer.7e812519.svg";